module.exports = __webpack_public_path__ + "cad37cf3f4a003f952eddad7694fc0bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/news1.png
// module id = 197
// module chunks = 0